import dayjs from 'dayjs';
import { APPLICATION_STEP } from '~/constants/applicationStep';

export default function operatorApplication({ $auth, store }) {
  const { user } = $auth;
  const migrationDate = dayjs('2020-09-29T12:00:00+00:00');
  const beforeMigration = dayjs($auth?.user?.attributes?.created_at).isBefore(migrationDate);
  const isVerified = !!$auth.user?.attributes?.email_verified_at;
  if (beforeMigration || isVerified) {
    const userId = user?.id || null;
    if (!user?.attributes?.application_done || userId === null) {
      store.dispatch('application/setApplicationStep', APPLICATION_STEP.NEW);
      return;
    }
    if (user.attributes?.welcomed) {
      const organizationId = user?.relationships?.organizations?.data[0]?.id || null;
      store.dispatch('application/fetchOperatorApplication', { userId, organizationId, flag: false });
    }
  }
}
